import { NBSP } from '../../../constants/symbols';
import { ELabelColor, IOfferCard } from '../../../types';

export const getGoodPriceLabel = ({ goodPrice }: IOfferCard) => {
  if (!goodPrice) {
    return;
  }

  return {
    color: ELabelColor.SimpleBlue,
    text: goodPrice.priceLabel,
    tooltip: {
      title: 'Почему цена хорошая',
      // eslint-disable-next-line no-irregular-whitespace
      description: `Хорошей мы считаем цену, которая попадает в${NBSP}диапазон оценки Циан. Для этой квартиры диапазон: ${goodPrice.estimationRange}`,
    },
  };
};
